/**
 * Canonical per-Space / per-Workspace access-level options — the single
 * source of truth for the value / label / description shown in every
 * "Share" and "People" dialog (Space share, Workspace people, …).
 *
 * The descriptions mirror what the backend actually enforces in the
 * permission matrix (flowdesk-api `middleware/permissions.js` PERMS) and the
 * task-service assignee bypass, so the UI can never drift from the API again
 * (two dialogs had drifted to three different, partly-wrong "Edit" strings —
 * which is why this constant exists). Keep in sync with PERMS:
 *   • full    — every action true, including `members.manage`.
 *   • edit    — create/edit everything + delete tasks/subtasks; NOT
 *               list/folder/document delete, NOT `members.manage`.
 *   • comment — read + comment; an assignee may change ONLY the status of
 *               their own task (never planning fields, never reassign).
 *   • view    — read-only; cannot comment.
 */
export const ACCESS_LEVEL_OPTIONS = [
  {
    value: 'full',
    label: 'Full edit',
    description: 'Edit and delete anything. Manage members.',
  },
  {
    value: 'edit',
    label: 'Edit',
    description:
      "Create and edit anything, and delete tasks and subtasks. Can't delete lists, folders or documents, or manage members.",
  },
  {
    value: 'comment',
    label: 'Comment',
    description:
      'Read-only, except assignees can update the status of their own tasks.',
  },
  {
    value: 'view',
    label: 'View only',
    description: "Read-only. Can't edit or comment.",
  },
]
